// extracted by mini-css-extract-plugin
module.exports = {"container":"cars-carousel-section_container__PN3yv","innerWrapper":"cars-carousel-section_innerWrapper__emv7t"};